import React from "react";
import { FiFileText, FiCalendar, FiHome, FiClock } from "react-icons/fi";

function RequestsCard({ request }) {
  //firebasedate converter
  const handleDate = (date) => {
    return new Date(date.seconds * 1000).toLocaleDateString();
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "approved":
        return "bg-green-100 text-green-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      case "returned":
        return "bg-blue-100 text-blue-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:shadow-md transition-all duration-200">
      <div className="flex items-start justify-between">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="p-2 bg-eleghoBlue/10 rounded-lg">
              <FiFileText className="w-4 h-4 text-eleghoBlue" />
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">
                {request.workPermitType}
              </div>
              <div className="text-xs text-gray-500">Work Permit Request</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <FiHome className="w-4 h-4 text-gray-400" />
              <div>
                <div className="text-xs text-gray-500">Unit</div>
                <div className="text-sm font-medium text-gray-900">
                  {request.identifier}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <FiClock className="w-4 h-4 text-gray-400" />
              <div>
                <div className="text-xs text-gray-500">Duration</div>
                <div className="text-sm font-medium text-gray-900">
                  {request.duration} days
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <FiCalendar className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Requested On</div>
              <div className="text-sm font-medium text-gray-900">
                {request.createdAt}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
            request.status
          )}`}
        >
          {request.status}
        </div>
      </div>
    </div>
  );
}

export default RequestsCard;
